import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import Lottie from 'react-lottie';

import styles from "components/PlayerStyles.module.scss";

const animations = [
    "bounce",
    "rubberBand",
    "shakeX",
    "shakeY",
    "headShake",
    "swing",
    "tada",
    "wobble",
    "jello",
    "heartBeat",
];

export default class Player extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showBubble: false,
        }
        this.potatoRef = React.createRef();
        this.bubbleRef = React.createRef();
        this.lastKnownGuessText = props.player.catchphraseData.lastGuessText || "";
        this.hideTimer = null;
        this.rafId = null;
    }

    componentDidMount() {
        //find any element with a tabindex and set it to -1, this is a hack to prevent the potato from being focused (react lottie has this hard coded))
        const elements = document.querySelectorAll('[tabindex]');
        elements.forEach(element => {
            element.setAttribute('tabindex', '-1');
        });
    }

    componentDidUpdate() {
        const newText = this.props.player.catchphraseData.lastGuessText;
        if (newText && newText !== this.lastKnownGuessText) {
            this.lastKnownGuessText = newText;
            if (this.hideTimer) clearTimeout(this.hideTimer);
            this.setState({ showBubble: true });
            this.hideTimer = setTimeout(() => this.setState({ showBubble: false }), 5000);
        }
        if (this.state.showBubble && this.rafId === null) {
            this.startTrackingBubble();
        } else if (!this.state.showBubble && this.rafId !== null) {
            this.stopTrackingBubble();
        }
    }

    componentWillUnmount() {
        if (this.hideTimer) clearTimeout(this.hideTimer);
        this.stopTrackingBubble();
    }

    updateBubblePosition = () => {
        const potato = this.potatoRef.current;
        const bubble = this.bubbleRef.current;
        if (potato && bubble) {
            const rect = potato.getBoundingClientRect();
            const visibleSize = Math.min(rect.width, rect.height);
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            const leftX = centerX + visibleSize / 2 - visibleSize * 0.1;
            const topY = centerY - visibleSize / 2 + visibleSize * 0.1;
            bubble.style.left = `${leftX}px`;
            bubble.style.top = `${topY}px`;
        }
        this.rafId = requestAnimationFrame(this.updateBubblePosition);
    };

    startTrackingBubble = () => {
        this.updateBubblePosition();
    };

    stopTrackingBubble = () => {
        if (this.rafId !== null) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }
    };

    animateCSS = (element, animation, prefix = 'animate__') =>
        // We create a Promise and return it
        new Promise((resolve, reject) => {
            const animationName = `${prefix}${animation}`;
            element.classList.add(`${prefix}animated`, animationName);

            // When the animation ends, we clean the classes and resolve the Promise
            function handleAnimationEnd(event) {
                event.stopPropagation();
                element.classList.remove(`${prefix}animated`, animationName);
                resolve('Animation ended');
            }

            element.addEventListener('animationend', handleAnimationEnd, { once: true });
        });

    doAnimation = (player) => {
        let animation = this.getRandomElement(animations);
        this.props.room?.send("animate_potato", { animation: animation, });
        const potato = document.getElementById(`potato-${player.id}`);
        if (potato) {
            this.animateCSS(potato, animation);
        }
    }

    getRandomElement(array) {
        return array[Math.random() * array.length >> 0];
    }

    renderSpeechBubble() {
        if (typeof document === 'undefined') return null;
        const catchphraseData = this.props.player.catchphraseData;
        const team = this.props.team;
        const showBubble = this.state.showBubble;
        const text = catchphraseData.lastGuessText || this.lastKnownGuessText;
        const bubble = (
            <div
                ref={this.bubbleRef}
                className={`${styles.speechBubble} ${showBubble && styles.show}`}
                style={{ "--team-colour": team ? team.colour : "grey" }}
            >
                {text}
            </div>
        );
        return createPortal(bubble, document.body);
    }

    render() {
        const catchphraseData = this.props.player.catchphraseData;
        const player = this.props.player;
        const team = this.props.team;
        const lockedOut = this.props.lockedOut;
        return (
            <div id={`player-${player.id}`}
                className={`${styles.player} ${styles.show} ${catchphraseData.isBuzzedIn && styles.isBuzzedIn} ${lockedOut && styles.lockedOut} ${this.props.large && styles.large}`}
                style={{ "--team-colour": team ? team.colour : "grey" }}
                onClick={() => this.doAnimation(player)}
                tabIndex='-1'
            >
                <div id={`potato-${player.id}`} ref={this.potatoRef} className={`${styles.potato}`}>
                    <img style={{ width: "100%", height: "100%", padding: "5%", objectFit: "contain" , transform: "translateY(-15%)" }} src={player.avatar} alt="avatar" />
                    <div className={`${styles.pass} ${catchphraseData.passed && styles.show}`}>PASS</div>
                </div>
                <div className={`${styles.textSection}`}>
                    <div className={styles.buzzer}>
                        <div className={styles.line}></div>
                    </div>
                    <div className={`${styles.name}`}>{player.connected ? player.name : "Not connected!"}</div>
                </div>
                {this.renderSpeechBubble()}
            </div>
        )
    }
}
